/**
 * Service for platform-wide settings (singleton).
 */
import useApi from '../utils/api';

class PlatformSettingsService {
  #prefix = '/platformSettings';

  fetchPublicSettings = () => {
    return useApi.get(`${this.#prefix}/public`);
  };

  fetchAdminSettings = () => {
    return useApi.get(this.#prefix);
  };

  updateSettings = (data) => {
    return useApi.put(this.#prefix, data);
  };
}

export default new PlatformSettingsService();
